import {
  EXCLUSIVE_TRIPS_LOADED,
  REGULAR_TRIPS_LOADED,
  ALL_TRIPS_LOADED,
  TRIP_LOADED,
  RETURN_TRIPS_LOADED,
  DEPARTURE_TRIPS_LOADED,
  EXCLUSIVE_PACKAGES_LOADED,
  REGULAR_PACKAGES_LOADED,
  DEPARTURE_PACKAGES_LOADED,
  ALL_PACKAGES_LOADED,
  OPERATORS_TRIPSPACKAGES_LOADED,
  ALL_COMMISIONS_LOADED,
  OPERATORS_COMMISIONS_LOADED,
} from "../actions/types";

const initialState = {
  token:
    typeof window !== "undefined" ? sessionStorage.getItem("token") : false,
  isAuthenticated: true,
  loadingExclusive: true,
  loadingRegular: true,
  exclusiveTrips: null,
  regularTrips: null,
  exclusivePackages: [],
  regularPackages: [],
  loadingAllTrips: true,
  allTrips: null,
  allPackages: null,
  trip: null,
  departureTrips: null,
  returnTrips: null,
  tripLoading: true,
  departurePackages: [],
  operatorsTripsPackages: [],
  allCommissions: [],
  operatorCommissions: [],
};

export default function (state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case REGULAR_TRIPS_LOADED:
      return {
        ...state,
        isAuthenticated: true,
        loadingRegular: false,
        regularTrips: payload,
      };

    case EXCLUSIVE_TRIPS_LOADED:
      return {
        ...state,
        isAuthenticated: true,
        loadingExclusive: false,
        exclusiveTrips: payload,
      };

    case ALL_TRIPS_LOADED:
      return {
        ...state,
        isAuthenticated: true,
        loadingAllTrips: false,
        allTrips: payload,
      };
    case ALL_PACKAGES_LOADED:
      return {
        ...state,
        allPackages: payload,
      };
    case DEPARTURE_TRIPS_LOADED:
      return {
        ...state,
        departureTrips: payload,
      };
    case RETURN_TRIPS_LOADED:
      return {
        ...state,
        returnTrips: payload,
      };

    case TRIP_LOADED:
      return {
        ...state,
        isAuthenticated: true,
        tripLoading: false,
        trip: payload,
      };
    case EXCLUSIVE_PACKAGES_LOADED:
      return {
        ...state,
        exclusivePackages: payload,
      };
    case REGULAR_PACKAGES_LOADED:
      return {
        ...state,
        regularPackages: payload,
      };
    case DEPARTURE_PACKAGES_LOADED:
      return {
        ...state,
        departurePackages: payload,
      };
    case OPERATORS_TRIPSPACKAGES_LOADED:
      return {
        ...state,
        operatorsTripsPackages: payload,
      };
    case ALL_COMMISIONS_LOADED:
      return {
        ...state,
        allCommissions: payload,
      };
    case OPERATORS_COMMISIONS_LOADED:
      return {
        ...state,
        operatorCommissions: payload,
      };
    default:
      return state;
  }
}
